// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3QA5Z","balanceDisclaimer":"posDashboard_balanceDisclaimer__21OH7"};